// Détection de la langue du système — « petit bonus » demandé le 14/09/2026 :
// l'application démarre dans la langue de l'appareil, français ou anglais,
// sans que le distributeur n'ait rien à choisir. Ne s'exécute qu'une seule
// fois, au tout premier lancement (voir App.js) — le choix, détecté ou
// changé manuellement ensuite, reste ce que l'utilisateur en a fait.
export const LANGUES_SUPPORTEES = ["fr", "en"];
export const LANGUE_PAR_DEFAUT = "fr";

/**
 * `langues` est la liste ordonnée des langues préférées du système
 * (`navigator.languages`, ex. ["en-US", "en", "fr"]) : on retient la
 * première qui correspond à une langue que l'application sait parler, sinon
 * le français, marché principal de Rise-T.
 */
export const detecterLangueSysteme = (langues = []) => {
  for (const langue of langues) {
    const code = String(langue || "").slice(0, 2).toLowerCase();
    if (LANGUES_SUPPORTEES.includes(code)) return code;
  }
  return LANGUE_PAR_DEFAUT;
};
